import React from 'react';
import { Bar } from 'react-chartjs-2';
import styled from 'styled-components';
import i18n from '../i18n';
import { Card, BoldTitle, CardTitle, CardBody } from '../styled/Card';
import { Grid, GridCol } from '../styled/Grid';

const placeData = (data) => {
  const { total_income, total_spent_on_therapy } = data;
  return ({
    labels: ['', ''],
    datasets: [
      {
        label: '',
        data: [total_income, total_spent_on_therapy],
        backgroundColor: ['#00B97F', '#9DD7E7'],
      },
    ],
  })
};

const TotalSpends = (props) => {
  const { data } = props;

  const options = {
    responsive: true,
    scales: {
      yAxes: [{
            display: true,
            ticks: {
                beginAtZero: true,
                min: 0
            }
        }]
    }
  }

  return (
    <Card>
      <CardTitle>{i18n.t('totalSpends.title')}</CardTitle>
      <CardBody padding={'10px 20px 10px 30px'}>
        <Grid>
          <GridCol $columns={6}>
            <SpendsWrap>
              <SpendsBox>
                <SpendsLabel>
                  <span className="arrow">&#10142;</span>
                  {i18n.t('totalSpends.totalIncome')}
                </SpendsLabel>
                <BoldTitle color="#00B97F">{ data.total_income }</BoldTitle>
              </SpendsBox>
              <SpendsBox>
                <SpendsLabel>
                  <span className="arrow left">&#10142;</span>
                  {i18n.t('totalSpends.totalSpends')}
                </SpendsLabel>
                <BoldTitle>{ data.total_spent_on_therapy }</BoldTitle>
              </SpendsBox>
            </SpendsWrap>
          </GridCol>
          <GridCol $columns={6}>
            <Bar
              data={placeData(data)}
              height={320}
              options={options}
            />
          </GridCol>
        </Grid>
      </CardBody>
    </Card>
  )
};

export default TotalSpends;

const SpendsWrap = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-evenly;
`;

const SpendsBox = styled.div`
  padding-left: 20px;
  position: relative;
`

const SpendsLabel = styled.h4`
  color: #717A81;
  font-size: 12px;
  line-height: 14px;
  font-weight: 500;
  margin: 0;
  margin-bottom: 5px;
  position: relative;
  > .arrow {
    position: absolute;
    color: #00B97F;
    font-size: 20px;
    left: -28px;
  }
  > .left {
    transform: rotate(180deg);
    color: #9DD7E7;
  }
`
